import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zammad = defineConnector({
  identifier: "zammad",
  name: "Zammad",
  tagLine: "Helpdesk and ticketing system",
  logo,
  protocol: "http",
  tags: ["it", "communication"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.zammad\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `token=${app.secret.apiKey}`,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Zammad instance, go to your **Profile > Token Access**, and create a new personal access token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Zammad host",
          placeholder: "support.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v1/users/me`,
  },
});
